import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import PbhRequestServiceableCreate from "./PbhRequestServiceableCreate";
import PbhRequestServiceableUpdate from "./PbhRequestServiceableUpdate";
import PbhRequestServiceableView from "./PbhRequestServiceableView";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";
import { useAuth } from "@airborne/react-admin";
import { Roles } from "../../../../../src/Enums/Roles";
import { OwnerType, OwnerTypeDesc } from "../../../../../src/Enums/OwnerTypes";

const PbhRequestServiceable = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  const { user } = useAuth();

  React.useEffect(() => {
    const aarFlyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
    const ownerCode = props?.requestDetailData?.ownerCode;
    const isEightWingsRole = user?.roles?.some(role => role === Roles.EightWings);
    const status = props?.requestServiceableData?.status;
    var tempTabType =
      props?.requestServiceableData === null
        ? ModelState.Create
        : user?.isCustomer == false ||
            (user?.isCustomer && status == ServiceableStatu.Offered) ||
            (isEightWingsRole && ownerCode == aarFlyDubai)
          ? ModelState.Edit
          : ModelState.View;

    setTabType(tempTabType);
  }, [props?.requestServiceableData]);

  switch (tabType) {
    case ModelState.Create:
      return (
        <PbhRequestServiceableCreate
          resource="/pbhrequestserviceables"
          basePath=""
          requestId={props.requestId}
          requestDetail={props?.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
          isPageDisabled={props.isPageDisabled}
        />
      );
    case ModelState.Edit:
      return (
        <PbhRequestServiceableUpdate
          serviceable={props.requestServiceableData}
          requestDetail={props?.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
          requestId={props.requestId}
          isPageDisabled={props.isPageDisabled}
        />
      );
    default:
      return (
        <PbhRequestServiceableView
          serviceable={props.requestServiceableData}
          requestDetail={props?.requestDetailData}
        />
      );
  }
};

export default PbhRequestServiceable;
